var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{attrs:{"aria-label":"Log in"},on:{"click":_vm.loginAuth}},[_vm._v(_vm._s(_vm.authenticated ? "mdi-account-circle" : "mdi-login-variant"))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }